/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S1_Provider_ContactInputs */

const tr_mesafeli_s1_provider_contact = /** @type {(inputs: Mesafeli_S1_Provider_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; iletişim`)
};

const en_mesafeli_s1_provider_contact = /** @type {(inputs: Mesafeli_S1_Provider_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; contact`)
};

const de_mesafeli_s1_provider_contact = /** @type {(inputs: Mesafeli_S1_Provider_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; Kontakt`)
};

const ru_mesafeli_s1_provider_contact = /** @type {(inputs: Mesafeli_S1_Provider_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`; контакт`)
};

/**
* | output |
* | --- |
* | "; contact" |
*
* @param {Mesafeli_S1_Provider_ContactInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s1_provider_contact = /** @type {((inputs?: Mesafeli_S1_Provider_ContactInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S1_Provider_ContactInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s1_provider_contact(inputs)
	if (locale === "de") return de_mesafeli_s1_provider_contact(inputs)
	if (locale === "ru") return ru_mesafeli_s1_provider_contact(inputs)
	return tr_mesafeli_s1_provider_contact(inputs)
});